import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateEventAccountUserMutationVariables = Types.Exact<{
  event_account_id: Types.Scalars['ID'];
  user_id: Types.Scalars['ID'];
  input: Types.UpdateEventAccountUserInput;
}>;


export type UpdateEventAccountUserMutation = { __typename?: 'Mutation', updateEventAccountUser: string };


export const UpdateEventAccountUserDocument = gql`
    mutation UpdateEventAccountUser($event_account_id: ID!, $user_id: ID!, $input: UpdateEventAccountUserInput!) {
  updateEventAccountUser(
    event_account_id: $event_account_id
    user_id: $user_id
    input: $input
  )
}
    `;
export type UpdateEventAccountUserMutationFn = Apollo.MutationFunction<UpdateEventAccountUserMutation, UpdateEventAccountUserMutationVariables>;

/**
 * __useUpdateEventAccountUserMutation__
 *
 * To run a mutation, you first call `useUpdateEventAccountUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventAccountUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventAccountUserMutation, { data, loading, error }] = useUpdateEventAccountUserMutation({
 *   variables: {
 *      event_account_id: // value for 'event_account_id'
 *      user_id: // value for 'user_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEventAccountUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventAccountUserMutation, UpdateEventAccountUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventAccountUserMutation, UpdateEventAccountUserMutationVariables>(UpdateEventAccountUserDocument, options);
      }
export type UpdateEventAccountUserMutationHookResult = ReturnType<typeof useUpdateEventAccountUserMutation>;
export type UpdateEventAccountUserMutationResult = Apollo.MutationResult<UpdateEventAccountUserMutation>;
export type UpdateEventAccountUserMutationOptions = Apollo.BaseMutationOptions<UpdateEventAccountUserMutation, UpdateEventAccountUserMutationVariables>;